import type { FC } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import type { ProfileAddress } from '@dhl/receiver-profile-api'

import { links } from '~/links.js'
import type { SearchResult } from '~/search/model/search.js'
import { SearchResultListItem, type SearchResultProps } from './SearchResultListItem.js'
import { HighlightedText } from './HighlightedText.js'
import { SearchResultSecondaryText } from './SearchResultSecondaryText.js'

type Props = SearchResultProps<SearchResult<ProfileAddress>>

export const AddressSearchResult: FC<Props> = ({ data }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { item: profileAddress, matches } = data

  const handleOpenClick = () => {
    const { addressId } = profileAddress

    navigate(links.editAddressLink({ addressId }), {
      state: {
        initialReferrer: location.pathname,
        origin: 'search',
      },
    })
  }

  const {
    addressId,
    address: { city, street, houseNumber, houseNumberSuffix, postalCode },
    name,
  } = profileAddress

  return (
    <SearchResultListItem
      key={addressId}
      secondary={
        <>
          <SearchResultSecondaryText>
            <HighlightedText disableTypography fieldKey="address.street" matches={matches}>
              {street} {houseNumber}
              {houseNumberSuffix}
            </HighlightedText>
          </SearchResultSecondaryText>
          <SearchResultSecondaryText>
            <HighlightedText disableTypography fieldKey="address.postalCode" matches={matches}>
              {postalCode}
            </HighlightedText>{' '}
            <HighlightedText disableTypography fieldKey="address.city" matches={matches}>
              {city}
            </HighlightedText>
          </SearchResultSecondaryText>
        </>
      }
      primary={
        <HighlightedText emphasis fieldKey="name" matches={matches}>
          {name}
        </HighlightedText>
      }
      onOpen={handleOpenClick}
    />
  )
}
